import React, { useEffect, useRef, useState } from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useDispatch, useSelector } from "react-redux";
import { setMforderPrintJobTicketModal } from "store/slice/ManufSlice";
import { transformDateValue } from "core/js/FormUtils";
import { Grid, Button, Typography } from '@mui/material';
import { use } from "react";
import ProductOrderListByStockoutProductForPDF from "./ProductOrderListByStockoutProductForPDF";

const StockOutReqPdfComponent = ({ stockoutReqObj }) => {
  const contentRef = useRef();
  const [pdfUrl, setPdfUrl] = useState(null);
  const { mobileView } = useSelector((state) => state.menu)
  const dispatch = useDispatch();
  const { stockoutproductList, stockoutproducttoproductorderList } = useSelector((state) => state.manufslice);

  const [productList, setProductList] = useState([]);

  useEffect(() => {
    setProductList(
      stockoutproductList.filter((stockoutproduct) => stockoutproduct.stockoutreqid === stockoutReqObj.id)
    )
  }, [stockoutproductList, stockoutReqObj.id]);

  // Call generatePDF on complete load of the component
  useEffect(() => {
    if (productList.length > 0) {
      // Wait for DOM to render
      setTimeout(() => {
        generatePDF();
      }, 0);
    }
    // eslint-disable-next-line
  }, [productList]);

  const generatePDF = async () => {
    const element = contentRef.current;
    // Use a higher scale for better quality in PDF
    const canvas = await html2canvas(element, { scale: 1 });

    const imgData = canvas.toDataURL("image/jpeg", 0.95);
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();   // 210mm
    const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm

    // Calculate image dimensions to fit A4 while maintaining aspect ratio
    let imgWidth = pdfWidth;
    let imgHeight = (canvas.height * pdfWidth) / canvas.width;
    if (imgHeight > pdfHeight) {
      imgHeight = pdfHeight;
      imgWidth = (canvas.width * pdfHeight) / canvas.height;
    }

    pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

    // Convert PDF to Blob URL for preview
    const pdfBlob = pdf.output("blob");
    const pdfBlobUrl = URL.createObjectURL(pdfBlob);
    setPdfUrl(pdfBlobUrl);
    if (mobileView) {
      window.open(pdfBlobUrl, "_blank");
      dispatch(setMforderPrintJobTicketModal(false));
    }
  };

  const getPrinting = (product) => {
    if (product.stockready) {
      if (product.withprinting)
        return product.printingtype ? 'Digital' : 'Screen'
      else
        return 'NA'
    } else
      return product.printingtype ? 'Digital' : 'Screen'

  }
  const getStitching = (product) => {
    if (product.stockready) {
      return 'NA'
    } else {
      return product.stitchingtype ? 'Simple' : 'Technical'
    }
  }
  const getStockDependentComponent = (product) => {
    if (product.stockready) {
      if (product.withprinting) {
        return <td style={styles.td}>{product.printingtype ? 'Digital' : 'Screen'}</td>
      }
    } else {
      return <>
        <td style={styles.td}>{product.printingtype ? 'Digital' : 'Screen'}</td>
        <td style={styles.td}>{product.stitchingtype ? 'Simple' : 'Technical'}</td>
      </>
    }
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px", }}>
      {/* PDF Content to Convert */}
      {!pdfUrl ?
        <div
          ref={contentRef}
          style={{
            width: "100%",
            minHeight: "50mm",
            padding: "5mm",
            fontSize: "12px",
            background: "#fff",
            //border: "1px solid #ddd",
          }}
        >
          {/* Header Section */}
          <Grid container sx={{ width: '100%' }}>
            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: 'center', justifyContent: 'flex-start', display: 'flex', borderBottom: '1px solid black' }}>
              <Grid container sx={{ width: '100%' }}>
                <Grid item lg={4} sm={12} md={4} xs={12} sx={{ textAlign: 'center', justifyContent: 'flex-start', alignItems: "center", display: 'flex', }}>
                  <img src="/assets/s-bags-logo.png" alt="Logo" style={{ width: "200px", height: "200px" }} />
                </Grid>
                <Grid item lg={4} sm={4} md={4} xs={12} sx={{ textAlign: 'center', justifyContent: 'center', display: 'flex', }}>
                  <Grid container sx={{ width: '100%' }}>
                    <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: 'center' }}>
                      <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24 }}>JAI MATA DI</Typography>
                    </Grid>

                    <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: 'center', justifyContent: 'center', display: 'flex' }}>
                      <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: 48 }}>STOCK OUT REQ NO - {stockoutReqObj.id}</Typography>

                    </Grid>


                  </Grid>
                </Grid>
                <Grid item lg={4} sm={4} md={4} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex', }}>
                  <Grid container sx={{ width: '100%' }}>
                    <Grid item lg={12} sm={12} md={12} xs={12}>&nbsp;</Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: 'center', justifyContent: 'flex-end', display: 'flex' }}>
                      <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 28, textDecoration: 'underline' }}>GST No.</Typography>
                    </Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: 'center', justifyContent: 'flex-end', display: 'flex' }}>
                      <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24 }}>07AASPN2194G1ZB</Typography>
                    </Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: 'right', justifyContent: 'flex-end', display: 'flex' }}>
                      <Grid container direction="column" sx={{ width: '100%' }}>
                        <Grid><Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24, }}>Mobile</Typography></Grid>
                        <Grid><Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 18, }}>98110 62362</Typography></Grid>
                        <Grid><Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 18, }}>88606 16189</Typography></Grid>
                        <Grid><Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 18, }}>70112 96950</Typography></Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid item lg={12} sm={12} md={12} xs={12} sx={{ padding: 3 }}>
              <Grid container sx={{ width: '100%' }}>
                <Grid item lg={6} sm={6} md={6} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex' }}>
                  <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24 }}>Stock Out Req No: </Typography>
                  <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24, color: 'primary.dark' }}>&nbsp;{stockoutReqObj.id}&nbsp; </Typography>
                </Grid>
                <Grid item lg={6} sm={6} md={6} xs={12} sx={{ textAlign: 'right', justifyContent: 'flex-end', display: 'flex' }}>
                  <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24 }}>Issue Date</Typography>
                  <Typography variant="h5" sx={{ fontWeight: 'bold', fontSize: 24, width: '200px', borderBottom: '1px solid black', color: 'primary.dark' }}>{transformDateValue(stockoutReqObj.creationTimestamp)}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>


          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: 'left', }}>
            <Grid container sx={{ width: '100%', paddingLeft: .5, borderBottom: '1px solid black', borderTop: '1px solid black' }}>
              <Grid item lg={1} md={1} sm={1} xs={1}><Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 'bold', fontSize: 24, borderRight: '1px solid black' }}>S. No.</Typography></Grid>
              <Grid item lg={3} md={3} sm={3} xs={3}><Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 'bold', fontSize: 24, borderRight: '1px solid black' }}>Product</Typography></Grid>
              <Grid item lg={2} md={1} sm={1} xs={1}><Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 'bold', fontSize: 24, borderRight: '1px solid black' }}>QTY.</Typography></Grid>
              <Grid item lg={6} md={7} sm={3} xs={3} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex' }}>
                <Grid container sx={{ width: '100%' }}>
                  <Grid item lg={2} md={3} sm={3} xs={3}><Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 'bold', fontSize: 24, borderRight: '1px solid black' }}>#</Typography></Grid>
                  <Grid item lg={8} md={3} sm={3} xs={3}><Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 'bold', fontSize: 24, borderRight: '1px solid black' }}>Party</Typography></Grid>
                  <Grid item lg={2} md={1} sm={1} xs={1}><Typography variant="h4" sx={{ paddingLeft: 1, fontWeight: 'bold', fontSize: 24, borderRight: '1px solid black' }}>Qty</Typography></Grid>
                </Grid>

              </Grid>
            </Grid>

            {productList.map((product, index) => (
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: 'left', borderBottom: '1px solid black' }}>
                <Grid container sx={{ width: '100%', }}>
                  <Grid item lg={1} md={1} sm={1} xs={1}><Typography variant="h6" sx={{ padding: 1, fontSize: 18, }}>{index + 1}</Typography></Grid>
                  <Grid item lg={3} md={1} sm={1} xs={1}><Typography variant="h6" sx={{ padding: 1, fontSize: 18, }}>{product.title}</Typography></Grid>
                  <Grid item lg={2} md={1} sm={1} xs={1}><Typography variant="h6" sx={{ padding: 1, fontSize: 18, }}>{product.qty}</Typography></Grid>
                  <Grid item lg={6} md={3} sm={3} xs={3} >
                    <ProductOrderListByStockoutProductForPDF stockoutproductid={product.id} />
                  </Grid>

                </Grid>
              </Grid>
            ))
            }

            <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: 'left', marginTop: '50px', paddingLeft:5, paddingRight:5}}>
              <Grid container direction="row" sx={{ width: '100%' }}>
                <Grid item lg={5} md={5} sm={5} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex', }}>
                  <Grid container  sx={{ width: '100%' }}>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex', }}>
                      <Typography variant="h5" sx={{ fontSize: 24 }}>Designated Person </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ paddingTop:2, textAlign: 'left', justifyContent: 'flex-start', display: 'flex', borderBottom: '1px solid black' }}>
                      <Typography variant="h5" sx={{ fontSize: 24 }}>&nbsp;</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ paddingTop:5, textAlign: 'left', justifyContent: 'flex-start', display: 'flex',}}>
                      <Typography variant="h5" sx={{ fontSize: 18 }}>Signature</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item lg={2} md={2} sm={2} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex', }}>&nbsp;
                </Grid>
                <Grid item lg={5} md={5} sm={6} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex' }}>
                  <Grid container  sx={{ width: '100%' }}>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: 'left', justifyContent: 'flex-start', display: 'flex' }}>
                      <Typography variant="h5" sx={{ fontSize: 24 }}>Approved By </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ paddingTop:2, textAlign: 'left', justifyContent: 'flex-start', display: 'flex', borderBottom: '1px solid black' }}>
                      <Typography variant="h5" sx={{ fontSize: 24 }}>&nbsp;</Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ paddingTop:5, textAlign: 'left', justifyContent: 'flex-start', display: 'flex',}}>
                      <Typography variant="h5" sx={{ fontSize: 18 }}>Signature</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            

          </Grid>

        </div> : <></>}

      {/* PDF Viewer (iframe) */}
      {pdfUrl && !mobileView && (
        <>
          <iframe
            id="pdfFrame"
            src={pdfUrl}
            style={{ width: "100%", height: "68vh", border: "1px solid #ddd" }}
            title="PDF Preview"
          />
          {/* <button
            onClick={handlePrint}
            style={{ marginTop: "10px", padding: "10px 20px", background: "#28a745", color: "#fff", border: "none", cursor: "pointer" }}
          >
            Print PDF
          </button> */}
        </>
      )}
    </div>
  );
};

// CSS Styles for Table
const styles = {
  th: {
    padding: "8px",
    border: "1px solid #000",
    textAlign: "left",
  },
  td: {
    padding: "5px",
    borderBottom: "1px solid #000",
  },
};

export default StockOutReqPdfComponent;
